import { render, staticRenderFns } from "./FreeMonthBanner.vue?vue&type=template&id=2b6a97db&scoped=true&"
import script from "./FreeMonthBanner.vue?vue&type=script&lang=js&"
export * from "./FreeMonthBanner.vue?vue&type=script&lang=js&"
import style0 from "./FreeMonthBanner.vue?vue&type=style&index=0&id=2b6a97db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6a97db",
  null
  
)

export default component.exports